import { Box, Button, Flex, Text, useDisclosure, RadioGroup, Stack, Radio, Select } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useState, useRef, useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';

const UPDATE_COMPLAINT_TYPE = gql`
	mutation add($id: String!, $complaintOnInsuranceCategories: ComplaintOnInsuranceCategories!) {
		setComplaintCategory(id: $id, complaintOnInsuranceCategories: $complaintOnInsuranceCategories)
	}
`;

export default function ComplaintCategoryRow(props) {
	const { t, i18n } = useTranslation();
	const currentLang = i18n.language;
	const { complaintId, complaintType, onChange } = props;
	const [selectedValue, setSelectedValue] = useState(complaintType ?? '');
	const isFirstRender = useRef(true);

	const [updateComplaintType, { data, loading, error }] = useMutation(UPDATE_COMPLAINT_TYPE);

	useEffect(() => {
		setSelectedValue(complaintType ?? '');
	}, [complaintType]);

	// ✅ Handle user change with await
	const handleChange = async (value) => {
		setSelectedValue(value);

		if (value === '') return;

		try {
			await updateComplaintType({
				variables: {
					id: complaintId,
					complaintOnInsuranceCategories: value,
				},
			});

			// ✅ Only trigger parent AFTER mutation completes
			if (onChange) onChange(value);
		} catch (err) {
			console.error('Update failed:', err);
		}
	};

	return (
		<>
			<Flex justifyContent="flex-start" alignItems="center" p={1} pl={2} pr={2} style={{ pageBreakInside: 'avoid' }} _hover={{ bg: 'gray.200' }}>
				<Text mr="2" fontWeight="500" w="120px" minW="120px">
					{t(props?.label)}:
				</Text>

				<Box ml="2" mr="4">
					<Select
						isDisabled={props?.disabled || loading}
						value={selectedValue}
						onChange={(e) => {
							handleChange(e.target.value);
						}}
						variant="filled"
						size="md"
						placeholder={t('Select Complaint Type')}
						fontSize="sm"
					>
						<option value="COMPLAINT_ON_DISPUTE_INSURANCE">{t('Complaint on dispute insurance')}</option>
						<option value="COMPLAINT_OF_DISSATISFACTION_ON_INSURANCE">{t('Complaint of dissatifaction on insurance')}</option>
					</Select>
				</Box>
			</Flex>
		</>
	);
}
